import React from 'react'
import PropTypes from 'prop-types'
import ArrowLeft from 'components/shared/icons/arrow-left'
import ArrowRight from 'components/shared/icons/arrow-right'

const SimplePagination = ({ limit, total, page, lastPage, prevClick, nextClick }) => {
  const handlePrevClick = () => {
    prevClick({ page: page - 1, limit })
  }

  const handleNextClick = () => {
    nextClick({ page: page + 1, limit })
  }

  return (
    <div className="flex items-center bg-secondary-graywhite rounded-lg py-1 px-2">
      <button
        disabled={page === 1 || !total}
        className={`text-xs text-primary-lightgray focus:outline-none border-r ${(page === 1 || !total) && 'cursor-not-allowed'}`}
        onClick={handlePrevClick}
      >
        <ArrowLeft width="20px" height="20px" />
      </button>
      <button
        disabled={page === lastPage}
        className={`text-xs text-primary-lightgray focus:outline-none ${page === lastPage && 'cursor-not-allowed'}`}
        onClick={handleNextClick}
      >
        <ArrowRight width="20px" height="20px" />
      </button>
    </div>
  )
}

SimplePagination.propTypes = {
  limit: PropTypes.number,
  total: PropTypes.number,
  page: PropTypes.number,
  lastPage: PropTypes.number,
  prevClick: PropTypes.func,
  nextClick: PropTypes.func,
}

export default SimplePagination
